import BaseAPI from "./base/base-api";
class JobPositionAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "JobPosition";
}

export default new JobPositionAPI();
